var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParticle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CC4E0"
    },
    d: "M267.199,370.551c21.635,0,39.168,17.533,39.168,39.168c0,21.635-17.533,39.168-39.168,39.168 s-39.168-17.533-39.168-39.168C228.031,388.084,245.564,370.551,267.199,370.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#439EE8"
    },
    d: "M283.691,432.396c-21.635,0-39.168-17.533-39.168-39.168c0-6.57,1.624-12.756,4.483-18.194 c-12.468,6.552-20.975,19.62-20.975,34.685c0,21.635,17.533,39.168,39.168,39.168c15.065,0,28.133-8.506,34.685-20.975 C296.449,430.771,290.261,432.396,283.691,432.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAEC8E"
    },
    d: "M440.364,440.642c17.079,0,30.922,13.843,30.922,30.922s-13.843,30.922-30.922,30.922 s-30.922-13.843-30.922-30.922c0-11.73,6.535-21.934,16.162-27.17C429.984,442.002,435.014,440.642,440.364,440.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBC96C"
    },
    d: "M454.794,488.056c-17.079,0-30.922-13.843-30.922-30.922c0-4.813,1.115-9.361,3.078-13.422 c-0.454,0.22-0.905,0.442-1.346,0.682c-9.627,5.236-16.162,15.441-16.162,27.17c0,17.079,13.843,30.922,30.922,30.922 c12.266,0,22.863-7.14,27.861-17.492C464.164,486.956,459.608,488.056,454.794,488.056z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF675C"
    },
    cx: 458.917,
    cy: 312.83,
    r: 41.23
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB3D5A"
    },
    d: "M475.925,337.052c-22.769,0-41.23-18.461-41.23-41.23c0-7.008,1.754-13.605,4.839-19.383 c-12.998,6.938-21.847,20.629-21.847,36.39c0,22.769,18.461,41.23,41.23,41.23c15.761,0,29.452-8.849,36.39-21.847 C489.529,335.298,482.933,337.052,475.925,337.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CC4E0"
    },
    d: "M460.979,7.731c21.635,0,39.168,17.533,39.168,39.168s-17.533,39.168-39.168,39.168 c-21.635,0-39.168-17.533-39.168-39.168S439.344,7.731,460.979,7.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#439EE8"
    },
    d: "M478.501,68.544c-21.635,0-39.168-17.533-39.168-39.168c0-6.297,1.494-12.241,4.133-17.512 c-12.839,6.429-21.656,19.696-21.656,35.035c0,21.635,17.533,39.168,39.168,39.168c15.338,0,28.606-8.817,35.035-21.656 C490.743,67.051,484.799,68.544,478.501,68.544z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FAEC8E"
    },
    cx: 96.096,
    cy: 81.944,
    r: 37.107
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBC96C"
    },
    d: "M112.588,102.559c-20.491,0-37.107-16.616-37.107-37.107c0-5.993,1.43-11.649,3.954-16.661 C67.313,54.896,58.99,67.446,58.99,81.944c0,20.491,16.616,37.107,37.107,37.107c14.498,0,27.048-8.323,33.153-20.446 C124.239,101.129,118.582,102.559,112.588,102.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF675C"
    },
    d: "M261.015,24.222c13.657,0,24.738,11.08,24.738,24.738s-11.08,24.738-24.738,24.738 s-24.738-11.08-24.738-24.738S247.358,24.222,261.015,24.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB3D5A"
    },
    d: "M277.507,61.329c-13.657,0-24.738-11.08-24.738-24.738c0-4.274,1.085-8.295,2.995-11.805 c-11.135,2.41-19.487,12.319-19.487,24.174c0,13.657,11.08,24.738,24.738,24.738c9.383,0,17.549-5.231,21.742-12.933 C281.065,61.131,279.31,61.329,277.507,61.329z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5CC4E0"
    },
    cx: 52.805,
    cy: 244.801,
    r: 35.045
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#439EE8"
    },
    d: "M69.297,263.354c-19.357,0-35.045-15.688-35.045-35.045c0-5.419,1.231-10.549,3.425-15.128 c-11.781,5.646-19.917,17.68-19.917,31.62c0,19.357,15.688,35.045,35.045,35.045c13.939,0,25.974-8.136,31.62-19.917 C79.846,262.124,74.716,263.354,69.297,263.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF675C"
    },
    d: "M63.391,401.195c28.469,0,51.537,23.068,51.537,51.537c0,28.459-23.068,51.537-51.537,51.537 c-28.459,0-51.537-23.078-51.537-51.537C11.854,424.263,34.932,401.195,63.391,401.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB3D5A"
    },
    d: "M85.789,485.994c-28.459,0-51.537-23.078-51.537-51.537c0-10.851,3.36-20.912,9.085-29.215 c-18.499,7.821-31.483,26.137-31.483,47.49c0,28.459,23.078,51.537,51.537,51.537c17.616,0,33.156-8.842,42.451-22.322 C99.679,484.553,92.903,485.994,85.789,485.994z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A19AA0"
    },
    cx: 256.892,
    cy: 250.985,
    r: 57.721
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#827980"
    },
    d: "M277.507,296.338c-31.881,0-57.721-25.841-57.721-57.722c0-16.679,7.082-31.696,18.393-42.234 c-22.691,7.775-39.007,29.275-39.007,54.602c0,31.881,25.841,57.721,57.721,57.721c15.201,0,29.021-5.884,39.329-15.488 C290.351,295.231,284.06,296.338,277.507,296.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9F8F9"
    },
    d: "M285.753,238.617c0-11.39-9.225-20.615-20.615-20.615s-20.615,9.225-20.615,20.615 c0,11.39,9.225,20.615,20.615,20.615S285.753,250.006,285.753,238.617z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 102.281,
    cy: 71.636,
    r: 10.307
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BEE7F3"
    },
    cx: 58.99,
    cy: 234.494,
    r: 8.246
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC2BE"
    },
    cx: 265.138,
    cy: 44.837,
    r: 8.246
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BEE7F3"
    },
    cx: 469.225,
    cy: 34.53,
    r: 10.307
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC2BE"
    },
    cx: 465.102,
    cy: 302.522,
    r: 10.307
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BEE7F3"
    },
    cx: 277.507,
    cy: 399.412,
    r: 8.246
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 446.548,
    cy: 465.38,
    r: 8.246
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC2BE"
    },
    cx: 75.482,
    cy: 440.642,
    r: 12.369
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360.803,158.928c1.978,0,3.957-0.754,5.467-2.264l69.956-69.956c7.189,4.487,15.671,7.089,24.752,7.089 c25.86,0,46.899-21.038,46.899-46.899S486.839,0,460.979,0c-25.86,0-46.899,21.038-46.899,46.899 c0,11.199,3.951,21.49,10.525,29.564l-69.269,69.269c-3.019,3.02-3.019,7.914,0,10.933 C356.846,158.173,358.825,158.928,360.803,158.928z M460.979,15.461c17.334,0,31.438,14.104,31.438,31.438 s-14.103,31.438-31.438,31.438s-31.438-14.104-31.438-31.438S443.645,15.461,460.979,15.461z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M458.917,263.87c-20.64,0-38.325,12.845-45.515,30.955l-91.953-33.103c0.579-3.495,0.896-7.079,0.896-10.736 c0-14.21-4.566-27.365-12.289-38.108l32.756-32.756c3.019-3.02,3.019-7.914,0-10.933c-3.02-3.018-7.914-3.018-10.933,0 l-32.269,32.269c-9.572-8.268-21.55-13.809-34.733-15.42l3.637-105.493c14.298-3.394,24.97-16.263,24.97-31.585 c0-17.903-14.565-32.468-32.468-32.468s-32.468,14.565-32.468,32.468c0,15.155,10.438,27.915,24.502,31.477l-3.64,105.538 c-12.41,1.419-23.769,6.324-33.086,13.707l-89.163-85.448c8.482-8.162,13.775-19.615,13.775-32.288 c0-24.723-20.114-44.837-44.837-44.837S51.26,57.222,51.26,81.945s20.113,44.836,44.836,44.836c6.364,0,12.417-1.341,17.906-3.742 l91.409,87.601c-8.017,10.206-13.076,22.837-13.857,36.601c-7.575-0.284-36.506-1.072-43.44-1.322 c-4.304-0.16-7.85,3.18-8.005,7.447s3.18,7.85,7.447,8.005c7.004,0.253,36.961,1.068,44.962,1.38 c2.313,12.688,8.291,24.107,16.801,33.122L99.448,405.742c-9.997-7.689-22.499-12.276-36.057-12.276 c-32.681,0-59.268,26.587-59.268,59.268s26.587,59.268,59.268,59.268s59.268-26.587,59.268-59.268 c0-13.559-4.587-26.06-12.276-36.057l110.849-110.849c8.351,5.449,18.01,9.046,28.402,10.199l3.268,49.032 c-18.887,6.061-32.6,23.787-32.6,44.662c0,25.86,21.038,46.899,46.899,46.899c25.86,0,46.899-21.038,46.899-46.899 c0-25.508-20.474-46.31-45.849-46.872l-3.129-46.945c9.913-1.249,19.138-4.72,27.165-9.903c7.666,8.545,14.821,16.611,22.697,25.581 c2.971,3.384,8.35,3.464,11.438,0.196c2.702-2.858,2.773-7.445,0.179-10.397c-7.771-8.851-14.847-16.826-22.392-25.242 c5.395-5.652,9.801-12.253,12.912-19.541l92.92,33.452c-0.053,0.921-0.085,1.848-0.085,2.782c0,26.996,21.964,48.96,48.96,48.96 c26.996,0,48.96-21.964,48.96-48.96C507.876,285.835,485.914,263.87,458.917,263.87z M66.72,81.944 c0-16.198,13.178-29.376,29.376-29.376s29.376,13.178,29.376,29.376s-13.178,29.376-29.376,29.376S66.72,98.142,66.72,81.944z  M244.008,48.96c0-9.378,7.63-17.007,17.007-17.007c9.378,0,17.007,7.63,17.007,17.007s-7.63,17.007-17.007,17.007 C251.637,65.967,244.008,58.338,244.008,48.96z M63.391,496.539c-24.155,0-43.806-19.651-43.806-43.806 c0-24.155,19.651-43.806,43.806-43.806s43.806,19.651,43.806,43.806C107.198,476.888,87.546,496.539,63.391,496.539z  M298.637,409.72c0,17.334-14.104,31.438-31.438,31.438s-31.438-14.104-31.438-31.438s14.104-31.438,31.438-31.438 S298.637,392.386,298.637,409.72z M256.892,300.976c-27.565,0-49.991-22.426-49.991-49.991s22.426-49.991,49.991-49.991 c27.565,0,49.991,22.426,49.991,49.991C306.883,278.551,284.458,300.976,256.892,300.976z M458.917,346.329 c-18.472,0-33.499-15.027-33.499-33.499s15.027-33.499,33.499-33.499c18.472,0,33.499,15.027,33.499,33.499 S477.389,346.329,458.917,346.329z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M440.364,432.911c-4.354,0-8.672,0.757-12.753,2.183c-4.869-5.373-9.739-10.746-14.604-16.127 c-19.611-21.69-42.659-47.354-64.915-73.246c-2.785-3.24-7.666-3.605-10.902-0.823c-3.237,2.783-3.605,7.665-0.823,10.902 c22.367,26.018,45.497,51.773,65.171,73.534c4.187,4.632,8.381,9.258,12.574,13.885c-7.798,7.22-12.4,17.432-12.4,28.343 c0,21.314,17.339,38.653,38.653,38.653s38.653-17.339,38.653-38.653S461.678,432.911,440.364,432.911z M440.364,494.756 c-12.787,0-23.192-10.404-23.192-23.192c0-8.503,4.647-16.311,12.126-20.379c0.003-0.002,0.006-0.004,0.009-0.006 c3.365-1.836,7.188-2.807,11.058-2.807c12.787,0,23.192,10.404,23.192,23.192S453.152,494.756,440.364,494.756z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.805,287.577c18.637,0,34.52-11.985,40.368-28.65l23.136,0.891c0.101,0.004,0.201,0.006,0.302,0.006 c4.132,0,7.559-3.268,7.719-7.434c0.164-4.266-3.16-7.857-7.428-8.021l-21.353-0.823c-0.669-23.006-19.579-41.52-42.745-41.52 c-23.586,0-42.776,19.189-42.776,42.776S29.22,287.577,52.805,287.577z M52.805,217.486c15.061,0,27.315,12.253,27.315,27.315 c0,15.061-12.252,27.315-27.315,27.315s-27.315-12.253-27.315-27.315C25.491,229.74,37.744,217.486,52.805,217.486z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M265.138,210.271c-15.629,0-28.345,12.716-28.345,28.345s12.716,28.345,28.345,28.345s28.345-12.716,28.345-28.345 S280.768,210.271,265.138,210.271z M265.138,251.501c-7.105,0-12.884-5.779-12.884-12.884s5.779-12.884,12.884-12.884 c7.105,0,12.884,5.779,12.884,12.884S272.243,251.501,265.138,251.501z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticle);
export default __webpack_public_path__ + "static/media/particle.ac5d64308328d561939f300bcc7333a6.svg";
export { ForwardRef as ReactComponent };